import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|Fulfillment Vouchers';

export type SPFulfillmentVoucherBulkUploadLocs = 'SPFulfillmentVoucherBulkUploadPageTitle';

export const spFulfillmentVoucherBulkUploadLocs: LocDefs<SPFulfillmentVoucherBulkUploadLocs> = {
	SPFulfillmentVoucherBulkUploadPageTitle: {
		defaultValue: 'Fulfillment Vouchers',
		description: 'Title displayed in the upload fulfillment vouchers page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialFulfillmentFulfillmentVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const spFulfillmentVoucherBulkUploadLocKeys = MapLocKeys<SPFulfillmentVoucherBulkUploadLocs>(
	spFulfillmentVoucherBulkUploadLocs
);

export type SPFulfillmentVoucherBulkUploadLocKeys = typeof spFulfillmentVoucherBulkUploadLocKeys;
